import React from 'react';
import { Card, Space, Typography, Tag } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import QueueMonitoringTable from './QueueMonitoringTable';
import { useCallCenter } from '../CallCenterContext';
import { useAuth } from '../../../context/AuthContext';

const { Text } = Typography;

const ActiveCampaignsWidget = () => {
    const {
        isLoadingCampaigns,
        campaigns,
        monitoredCalls,
        monitoredTimers
    } = useCallCenter();
    const { permissions } = useAuth();

    return (
        <Card
            className="active-campaigns-card"
            id="active-campaigns-card"
            size="small"
            title={<Text strong>{permissions.includes('agent.callcenter.view_queue') ? 'Campañas activas y monitoreo de llamadas' : 'Campañas Activas'}</Text>}
            style={{ marginBottom: 16 }}
        >
            <Space direction="vertical" style={{ width: '100%' }} size="small">
                <Space wrap>
                    {isLoadingCampaigns ? (
                        <Text type="secondary">Cargando campañas...</Text>
                    ) : campaigns.length > 0 ? (
                        campaigns.map(camp => (
                            <Tag
                                key={camp.id}
                                color={camp.type === 'inbound' ? 'cyan' : (camp.weight > 5 ? 'volcano' : 'orange')}
                                style={{ padding: '4px 12px', fontSize: '13px' }}
                            >
                                {camp.type === 'inbound' ? <ArrowDownOutlined /> : <ArrowUpOutlined />}
                                {camp.name} ({camp.type === 'inbound' ? 'Inbound' : 'Outbound'})
                            </Tag>
                        ))
                    ) : (
                        <Text type="secondary">Sin campañas asignadas</Text>
                    )}
                </Space>

                {permissions.includes('agent.callcenter.view_queue') && monitoredCalls.length > 0 && (
                    <QueueMonitoringTable
                        calls={monitoredCalls}
                        timers={monitoredTimers}
                    />
                )}
            </Space>
        </Card>
    );
};

export default ActiveCampaignsWidget;
